<!-- <nav style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb" class="mb-1 px-1">
	<ol class="breadcrumb">
		<li class="breadcrumb-item" *ngFor="let item of breadcrumbList; let i = index"
			[class.active]="i===breadcrumbList.length-1">
			<a [routerLink]="item.path" *ngIf="i!==breadcrumbList.length-1">
				<strong>{{ item.name }}</strong>
			</a>
			<span *ngIf="i===breadcrumbList.length-1"><strong>{{ item.name }}</strong></span>
		</li>
	</ol>
</nav> -->
<nav class="custom-breadcrumbs">
	<ng-container *ngFor="let item of breadcrumbList; let i = index">
		<a *ngIf="i!==breadcrumbList.length-1" [routerLink]="item.path" class="custom-breadcrumb-item">
			{{ item.name }}
		</a>
		<span *ngIf="i===breadcrumbList.length-1" class="custom-breadcrumb-item active-breadcrumb">
			{{ item.name }}
		</span>
	</ng-container>
</nav>